import { Plural, Trans } from '@lingui/react/macro'

export function AlbumMeta({
  hasMorePhotos,
  captureDate,
  photoCount,
}: {
  hasMorePhotos: boolean
  captureDate: string
  photoCount: number
}) {
  const hasPhotos = !!photoCount
  return (
    <div className="body-sm-ln flex flex-wrap items-center gap-x-2 text-grey4">
      {captureDate && <span>{captureDate}</span>}

      {hasPhotos && captureDate && <span aria-hidden="true">•</span>}

      {hasPhotos ? (
        <span>
          <Plural value={photoCount || 0} one="# photo" other="# photos" />
        </span>
      ) : (
        <span>
          <Trans>Empty album</Trans>
        </span>
      )}

      {hasMorePhotos && <span aria-hidden="true">+</span>}
    </div>
  )
}
